import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.#addAnchors()
    this.#scrollToHash()
  }

  #addAnchors() {
    this.element.querySelectorAll("h2, h3, h4").forEach(heading => {
      if (heading.id) return
      heading.id = this.#slugify(heading.textContent)
      const link = document.createElement("a")
      link.href = `#${heading.id}`
      link.className = "heading-anchor"
      link.textContent = "#"
      link.addEventListener("click", (e) => {
        e.preventDefault()
        history.pushState(null, "", `#${heading.id}`)
        heading.scrollIntoView({ behavior: "smooth" })
      })
      heading.appendChild(link)
    })
  }

  #scrollToHash() {
    const hash = window.location.hash.slice(1)
    if (!hash) return
    const target = this.element.querySelector(`#${CSS.escape(hash)}`)
    if (target) target.scrollIntoView({ behavior: "smooth" })
  }

  #slugify(text) {
    return text.trim().toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
  }
}
